export default __webpack_public_path__ + "static/media/miniLogo.34860dd6.svg";